/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ВНИМАНИЕ! Когда сюда что-то добавляете проверьте все места где исопльзуется существующее какое-то значение и добавьте туда обработку нового
 * @export
 * @enum {string}
 */
export var FxIdDomainStoreEnumsSupportedWebPublishingPlatform;
(function (FxIdDomainStoreEnumsSupportedWebPublishingPlatform) {
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["FxId"] = 0] = "FxId";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["VkontaktePlay"] = 1] = "VkontaktePlay";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["Odnoklassniki"] = 2] = "Odnoklassniki";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["VkontakteCom"] = 3] = "VkontakteCom";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["YandexGames"] = 4] = "YandexGames";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["AbsoluteGames"] = 5] = "AbsoluteGames";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["Kongregate"] = 6] = "Kongregate";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["FacebookGames"] = 7] = "FacebookGames";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["CrazyGames"] = 8] = "CrazyGames";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["WizQ"] = 9] = "WizQ";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["Telegram"] = 10] = "Telegram";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["FxLauncher"] = 11] = "FxLauncher";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["FxNative"] = 12] = "FxNative";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["Steam"] = 13] = "Steam";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["FacebookInstantGames"] = 14] = "FacebookInstantGames";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["WechatMiniGame"] = 15] = "WechatMiniGame";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["Unspecified"] = -1] = "Unspecified";
    FxIdDomainStoreEnumsSupportedWebPublishingPlatform[FxIdDomainStoreEnumsSupportedWebPublishingPlatform["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainStoreEnumsSupportedWebPublishingPlatform || (FxIdDomainStoreEnumsSupportedWebPublishingPlatform = {}));
export function instanceOfFxIdDomainStoreEnumsSupportedWebPublishingPlatform(value) {
    for (const key in FxIdDomainStoreEnumsSupportedWebPublishingPlatform) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainStoreEnumsSupportedWebPublishingPlatform, key)) {
            if (FxIdDomainStoreEnumsSupportedWebPublishingPlatform[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainStoreEnumsSupportedWebPublishingPlatformFromJSON(json) {
    return FxIdDomainStoreEnumsSupportedWebPublishingPlatformFromJSONTyped(json, false);
}
export function FxIdDomainStoreEnumsSupportedWebPublishingPlatformFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainStoreEnumsSupportedWebPublishingPlatformToJSON(value) {
    return value;
}
export function FxIdDomainStoreEnumsSupportedWebPublishingPlatformToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainStoreEnumsSupportedWebPublishingPlatform.js.map